import DeviceInfoIcon from "./DeviceInfoIcon";

export default DeviceInfoIcon;
